










import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';

@Component
export default class InputRadio extends Vue {
	@Prop({ required: true })
	value!: any;

	@Prop({ type: String, required: true })
	name!: string;

	@Prop({ type: String, required: false, default: '' })
	label!: string;

	@Prop({ type: String, required: false, default: '#000' })
	color!: string;

	@Model('change', { default: '' }) readonly modelValue!: Object | string;

	get id() {
	    return this.name + new Date().valueOf();
	}

	get listeners() {
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    const { change, ...listeners } = this.$listeners;
	    return listeners;
	}

	get shouldBeChecked() {
	    return this.modelValue === this.value;
	}

	changedInput(event: any) {
	    this.$emit('change', this.value);
	}
}
